<ion-header>
  <ion-toolbar #toolbar>
    <ion-buttons slot="start">
      <ion-button appClick (clicked)="onClose()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title><span id="page-title-span">{{ 'Adresse ' | translate }} {{ adresse?.AdressNummer }}</span></ion-title>
  </ion-toolbar>
</ion-header>

<ion-content *ngIf="adresse"  class="section-content" #content>
  <div class="section">
    <div class="mb-25">
      <div class="adresse">
        <h1>{{ 'Adresse' | translate }}</h1>
        <app-adresse [adresse]="adresse" title="Adresse" [buttonsAnzeigen]="false"></app-adresse>
      </div>
    </div>

    <!-- <div class="mb-25">
      <div class="adresse" *ngIf="adresse" >
        <h1>{{ 'Abholadresse' | translate }}</h1>
        <app-adresse [adresse]="vertrag.Abholadresse" title="Einsatzort" [buttonsAnzeigen]="false"></app-adresse>
      </div>
    </div> -->
<!-- 
    <div class="mb-25 preLine">{{ adresse.Text }}</div> -->

  </div>

  <div class="section buttons-section">
    <ion-button expand="full" color="primary" size="large" appClick (clicked)="onNeuerAuftrag()">{{ 'Neuer Auftrag' | translate }}</ion-button>
    <ion-button expand="full" color="dark" fill="clear" appClick (clicked)="onClose()">{{ 'Abbrechen' | translate }}</ion-button>
  </div>

  <div class="footer-space"></div>
</ion-content>
